module.exports = __webpack_public_path__ + "img/taiwanbg.afe5e66f.png";